import axios from 'axios';
import moment from 'moment';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { alertRef } from '../../../App';
import Modal from '../../../Components/Modal/Modal';
import { Button } from '../../../Components/StyledComponents';
import { convertCost, onlyNum } from '../../../Utils/functions';
import './ReqJungsan.scss';

const ReqJungsan = () => {
    const [ remainPrice, setRemainPrice ] = React.useState(0)//보유 금액
    const [ reqPrice, setReqPrice ] = React.useState('')//정산 신청 금액
    const [ list, setList ] = React.useState([])//정산 신청 목록

    const navigate = useNavigate();

    const reqModal = React.useRef(null);

    useEffect(() => {
        getDeposit()
    },[])

    //정산 보유 금액 Get
    const getDeposit = () => {
        axios.get('/api/deposit')
        .then((data) => {
            setRemainPrice(data.data.Deposit)
            getRecentJungsan()
        })
    }

    //정산 출금 신청
    const reqWithdraw = () => {
        axios.post('/api/withdraw',{
            Price : parseInt(reqPrice)
        })
        .then((data) => {
            if(data.status === 204){
                setReqPrice('')
                getDeposit();
                reqModal.current.closeModal();
                alertRef.current.showAlert({ title : '정산 신청이 완료 되었어요.', isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    //최근 정산 목록 Get
    const getRecentJungsan = () => {
        axios.get('/api/jungsan/recent')
        .then((data) => {
            setList(data.data)
        })
    }

    //정산 신청 금액 handler
    const handlePrice = (val) => {
        if(parseInt(val) > remainPrice) setReqPrice(remainPrice)
        else setReqPrice(val)
    }

    return (
        <div className='req-jungsan'>
            <div className='jungsan-box'>
                <div className='row between'>
                    <div>
                        <p className='jungsan-text'>현재 출금 가능 금액</p>
                        <div className='row' style={{ marginTop : 8 }}>
                            <p className='jungsan-price'>{convertCost(remainPrice)}원</p>
                            <p className='jungsan-text'>&nbsp;입니다.</p>
                        </div>
                    </div>

                    <Button variant='main' className='req-jungsan-btn' onClick={() => {setReqPrice('');reqModal.current.openModal()}}>
                        <div className='row'>
                            <img src={require('../../../aseets/icons/alert-white.svg').default} style={{ width : 32, height : 32, marginRight : 8 }} />
                            정산요청
                        </div>
                    </Button>
                </div>
            </div>

            <p className="sub-title">최근 정산 내역</p>

            <table>
                <tbody>
                    <tr>
                        <th>처리일</th>
                        <th>구분</th>
                        <th>변동 금액</th>
                        <th>변동 후 금액</th>
                        <th>변동 사유</th>
                    </tr>
                    {
                        list.map((data,i) => {
                            return(
                                <tr key={i}>
                                    <td>{data.Type === 'Withdraw' ? data.State === 'Done' ? moment(data.WithdrawDate.$date).utc().format('YY-MM-DD(dd)') : moment(data.Date.$date).utc().format('YY-MM-DD(dd)') :  moment(data.Date.$date).utc().format('YY-MM-DD(dd)')}</td>
                                    <td>{data.Type === 'Deposit' ? '정산금 적립' : '정산금 출금'}</td>
                                    <td>{convertCost(data.Variance)}</td>
                                    <td style={{ fontSize : 18, fontWeight : '500', lineHeight : 1.78, color : '#3f3f3f'}}>{convertCost(data.After)}</td>
                                    <td>{(typeof data.Reason === 'undefined' ? '-' : data.Reason )}</td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>

            <div style={{ display : 'flex', width : '100%',justifyContent : 'center', alignItems : 'center'}}>
                <button className="more-btn" onClick={() => navigate('/history/jungsan-history')}>
                    전체내역 보러가기
                </button>
            </div>

            {/* 출금 신청 모달 */}
            <Modal ref={reqModal} contentContainer={{ width : 500 }} isHeader title={'정산 요청'}>
                <div>
                    <p className='input-label-text'>인출금액</p>
                    <label htmlFor={`req-price`} data-domain="원">
                        <input
                            className='underline-input'
                            value={reqPrice}
                            onChange={(e) => handlePrice(onlyNum(e.target.value))}
                            placeholder={'1,952,812'}
                        />
                    </label>

                    <div className='btn-row'>
                        <Button
                            variant="main"
                            fontSize={16}
                            style={{ width : 118, alignSelf: 'flex-end' }}
                            disabled={ parseInt(reqPrice) === 0 || parseInt(reqPrice) < 1000 || reqPrice === '' }
                            onClick={() => reqWithdraw()}
                        >
                            인출하기
                        </Button>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default ReqJungsan;